import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

Vue.prototype.$axios = axios;

console.log(`NODE_ENV=${process.env.NODE_ENV}`);

if (process.env.NODE_ENV === 'development') {
  Vue.config.API_ENDPOINT = 'https://1zsojhwd0k.execute-api.us-east-1.amazonaws.com/dev';
} else {
  Vue.config.API_ENDPOINT = 'https://mobilibus.com/api';
}

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
